import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as ChevronRight } from "../../../assets/icons/notifications/chevron-right.svg"
import "./index.css";

const DateTimePicker = ({ value, onApply, onClear }) => {
	const [selectedDateTime, setSelectedDateTime] = useState(value || null);

	const handleClear = () => {
		setSelectedDateTime(null);
		onClear && onClear();
	};

	const handleApply = () => {
		if (selectedDateTime && onApply) {
			onApply(selectedDateTime);
		}
	};

	useEffect(() => {
		if (value) {
			setSelectedDateTime(value);
		}
	}, [value]);

	return (
		<div className="dateTimePickerContainer">

			<DatePicker
				selected={selectedDateTime}
				onChange={(date) => setSelectedDateTime(date)}
				showTimeSelect
				timeIntervals={30}
				dateFormat="dd/MM/yyyy HH:mm"
				timeFormat="HH:mm"
				inline
				calendarClassName="custom-datepicker"
				minDate={new Date()}
				minTime={
					selectedDateTime && selectedDateTime.toDateString() === new Date().toDateString()
						? new Date()
						: new Date(0, 0, 0, 0, 0)
				} // ⬅️ Prevent past times for today
				maxTime={new Date(0, 0, 0, 23, 30)} // ⬅️ Optional: restrict to valid time range
			/>

			<div role="DateTime display" className="dateTimeDisplayContainer">
				<div className="dateTimeDisplayText flex items-center gap-3">
					{selectedDateTime ? (
						<>
							<span>{selectedDateTime.toLocaleDateString('en-GB')}</span>
							<ChevronRight className="w-5 h-5" />
							<span>{selectedDateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false, })}</span>
						</>
					) : (
						<span>No date selected</span>
					)}
				</div>
			</div>

			<div className="dateTimePickerFooter">


				<div className="dateTimePickerButtons">
					<button className="clearBtn" onClick={handleClear}>
						<span className="clearBtnText">Clear</span>
					</button>
					<button
						className={`applyBtn ${!selectedDateTime ? 'applyBtnInactive' : 'applyBtnActive'}`}
						disabled={!selectedDateTime}
						onClick={handleApply}
					>
						<span className="applyBtnText">Apply</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default DateTimePicker;
